import React from "react";
import dynamic from "next/dynamic";
import { getFlagList } from "../../helpers/flags-helper";
import classnames from "classnames";

const convertCountries: Record<string, string> = {
  uk: "united-kingdom",
  usa: "united-states",
};

interface Props {
  country?: string;
  className?: string;
}

const Flag = ({ country = "united-kingdom", className }: Props) => {
  if (country === "undefined" || !country) return null;
  let currentCountry: null | string = null;
  const countries: Record<string, string> = getFlagList();
  if (convertCountries.hasOwnProperty(country)) {
    currentCountry = countries[convertCountries[country]];
  } else {
    currentCountry = countries[country];
  }

  const classes = classnames("ef-flag", "ef-svg", className);

  if (typeof currentCountry === "undefined") {
    return <div />;
  }
  const DynamicFlag = dynamic<React.ComponentProps<"svg">>(
    () => import(`./flags/${currentCountry}.svg`)
  );

  return <DynamicFlag className={classes} />;
};

export default Flag;
